import React from 'react';
import '../styles/dashboard.css';

function Dashboard() {
  return (
    <div>
      <h1>Dashboard</h1>
      <p>Welcome to the MediClaims Dashboard.</p>
    </div>
  );
}

export default Dashboard;